<template>
	<v-contextual-content :class="classes" class="account">
		<template v-slot:trigger="{ toggle }">
			<v-tooltip placement="bottom">
				<button @click="toggle" v-html="$present('initials', $authed().profile)"/>
				<template v-slot:popover>
					Account
				</template>
			</v-tooltip>
		</template>
		<div class="account__dropdown">
			<div class="account__dropdown__auth-summary flex gap-2">
				<dl>
					<dt class="sr-only">User</dt>
					<dd class="beta heavy">
						<!--						<p-->
						<!--							v-if="$impersonator()"-->
						<!--							class="account__impersonation">Impersonating {{ $present("fullName", $authed().profile) }}</p>-->
						<nobr v-html="$present('fullName', $authed().profile)"/>
					</dd>
					<dd class="text--light nobr" v-html="$authed().email"/>
					<dd
						v-if="$authed().service_provider" class="text--light"
						v-html="$authed().service_provider.profile.name"/>
				</dl>
				<figure>
					<figcaption v-html="$authed().profile.initials"/>
				</figure>
			</div>
			<ul class="account__dropdown__options">
				<li>
					<AppLink
						:to="{name: 'settings.profile'}" class="account__dropdown__options__profile">Profile
					</AppLink>
				</li>
				<li>
					<AppLink :to="{name: 'settings'}" class="account__dropdown__options__settings">Settings</AppLink>
				</li>
				<li>
					<button
						v-if="!$impersonator()"
						class="account__dropdown__options__sign-out"
						@click.prevent="logout()">Sign Out
					</button>
					<button
						v-else
						class="account__dropdown__options__sign-out"
						@click.prevent="endImpersonation()">Stop Impersonating
					</button>
				</li>
			</ul>
		</div>
	</v-contextual-content>
</template>
<script>
import {mapActions} from "vuex";

export default {
	computed: {
		classes() {
			return {
				"account--impersonating": this.$impersonator(),
			};
		},
	},
	methods: {
		...mapActions("authStore", [
			"endImpersonation",
			"logout",
		]),
	},
};
</script>
